// extracted by css-extract-rspack-plugin
module.exports =  {"spinner-outer":"Show-ocnh__spinner-outer","spinner":"Show-NlXL__spinner"};